import React from "react";

class CustomIconButton extends React.PureComponent {
  constructor(props) {
    super(props);
  }

  render() {
    const { disabled, onClick, icon, title } = this.props;

    return (
      <>
        <div
          className={"swift-button-icon " + (disabled ? "disabled" : "")}
          onClick={!disabled ? onClick : () => { }}
        >
          <p>{title}</p>
          <div className="button-icon">{icon}</div>
        </div>
      </>
    );
  }
}

export default CustomIconButton;
